import { Box, Grid, GridItem, Image, VStack } from '@chakra-ui/react';

import { IInstanceDetail } from '@libraries/api/instance/instance.types';
import { configEnv } from '@libraries/config';
import { memo } from 'react';
import { Form } from './Partials';

interface IProps {
  detail: IInstanceDetail;
}
const Login: React.FC<IProps> = ({ detail }): JSX.Element => {
  return (
    <Box bg="white">
      <Grid
        templateColumns={{
          base: '1fr',
          md: '1fr 400px',
          lg: '1fr 500px',
        }}
        alignItems="stretch"
        minH="100vh"
      >
        <GridItem
          display={{
            base: 'none',
            md: 'block',
          }}
        >
          <Image
            alt={configEnv.appName}
            src={
              detail?.login_banner || `${configEnv.assetUrl}/il/il-login.webp`
            }
            w="full"
            h="full"
            objectFit="cover"
          />
        </GridItem>
        <GridItem>
          <VStack
            align="stretch"
            justify="center"
            minH="100vh"
            p={{
              base: '4',
              lg: '8',
            }}
            bg="bg.primary"
          >
            <Form detail={detail} />
          </VStack>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default memo(Login);
